import axios from 'axios';
import { getBackendHost } from '../utils/backendHost';

const authPayload = () => ({
  jwt_token: localStorage.getItem('jwt_authorization'),
});

export async function getAvailablePhoneNumbers(areaCode = '') {
  const response = await axios.post(`${getBackendHost()}/phone-numbers`, {
    ...authPayload(),
    ...(areaCode ? { area_code: areaCode } : {}),
  });
  return Array.isArray(response.data) ? response.data : [];
}

export async function claimPhoneNumber(number) {
  const response = await axios.post(`${getBackendHost()}/claim-phone-number`, {
    ...authPayload(),
    phone_number: number.phone_number,
    region: number.region || '',
  });
  return response.data;
}
